import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function intToChar(n: number): string {
  return String.fromCharCode(96 + n);
}

export function getFileNameFromUrl(url) {
  const urlObj = new URL(url);
  const pathname = urlObj.pathname;
  const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
  return decodeURIComponent(fileName);
}

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export function isImageFilename(filename) {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'svg', 'heic', 'heif', 'avif'];
  const ext = filename.split('.').pop().toLowerCase();
  return imageExtensions.includes(ext);
}

export function removeExtension(filename: string): string {
  const dotIndex = filename.lastIndexOf('.')
  return dotIndex === -1 ? filename : filename.slice(0, dotIndex)
}